import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SupportTripOriginState {
  supportTripOrigin: Parameter[];
  setSupportTripOrigin: (newSupportTripOrigin: Parameter[] | undefined) => void;
}

export const useSupportTripOriginStore = create<SupportTripOriginState>()(
  devtools(
    (set) => ({
      supportTripOrigin: [],
      setSupportTripOrigin: (newSupportTripOrigin) =>
        set(() => ({
          supportTripOrigin: newSupportTripOrigin ? [...newSupportTripOrigin] : [],
        })),
    }),
    { name: "SupportTripOriginStore" }
  )
);
